'use client';

import { Card } from '@/app/(components)/shared/Card/Card';
import StructuredText from '@/app/(components)/shared/StructuredText';
import { mq } from '@/lib/StyledComponents/mq';
import { type StructuredTextGraphQlResponse } from 'react-datocms';
import styled from 'styled-components';

const StyledCard = styled(Card)<{ $textAlign?: 'left' | 'center' | 'right' }>`
  text-align: ${({ $textAlign }) => $textAlign ?? 'left'};
  max-width: 48rem;

  h3 {
    font-size: 2rem;
  }

  p,
  a {
    font-size: 1rem;
  }

  li::marker {
    color: ${({ theme }) => theme.colors.main.primary};
  }

  ${mq(null, 'laptop')} {
    width: 90%;
    h3 {
      font-size: 1.125rem;
    }

    p,
    a {
      font-size: 0.875rem;
    }
  }
`;

export const CardWithStructuredText = ({
  structureText,
  textAlign,
}: {
  structureText?: StructuredTextGraphQlResponse;
  textAlign?: 'left' | 'center' | 'right';
}) => {
  return (
    <StyledCard $textAlign={textAlign}>
      <StructuredText data={structureText} />
    </StyledCard>
  );
};
